"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_TASK_DETAILS = void 0;
const gql_1 = require("../../../../../__generated__/gql");
exports.GET_TASK_DETAILS = (0, gql_1.gql)(`
  query HLQATaskDetails(
    $catalogId: ID!,
    $productTreeId: ID!,
    $filter: PriorityTasksFilter
  ) {
    catalog(id: $catalogId) {
      id
      priorityTasks(productTreeId: $productTreeId, filter: $filter, first: 1) {
        edges {
          node {
            status
            escalationReason
            instructions
            instructionsUpdatedAt
            productTreeNodeId
            productLabelValidationId
            task
          }
        }
      }
    }
  }
`);
